'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.requestCaptchaIfNeeded = exports.failureCaptcha = exports.receiveCaptcha = exports.requestCaptcha = exports.FAILURE_CAPTCHA = exports.RECEIVE_CAPTCHA = exports.REQUEST_CAPTCHA = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _api = require('../api');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST_CAPTCHA = exports.REQUEST_CAPTCHA = 'REQUEST_CAPTCHA'; /**
                                                                    * 短信验证码相关Actions
                                                                   */
var RECEIVE_CAPTCHA = exports.RECEIVE_CAPTCHA = 'RECEIVE_CAPTCHA';
var FAILURE_CAPTCHA = exports.FAILURE_CAPTCHA = 'FAILURE_CAPTCHA';

var requestCaptcha = exports.requestCaptcha = function requestCaptcha(mobile) {
    return {
        type: REQUEST_CAPTCHA,
        mobile: mobile
    };
};

var receiveCaptcha = exports.receiveCaptcha = function receiveCaptcha(mobile, json) {
    return {
        type: RECEIVE_CAPTCHA,
        received_at: +(0, _moment2.default)()
    };
};
var failureCaptcha = exports.failureCaptcha = function failureCaptcha(error) {
    var ok = error.ok,
        status = error.status,
        statusText = error.statusText,
        type = error.type,
        url = error.url;

    return {
        type: FAILURE_CAPTCHA,
        error: { ok: ok, status: status, statusText: statusText, type: type, url: url }
    };
};

var shouldRequestCaptcha = function shouldRequestCaptcha(state) {
    var captcha = state.captcha;
    var now = Date.now();
    if (captcha.isFetching || captcha.exp >= now) {
        return false;
    }
    return true;
};

var requestCaptchaIfNeeded = exports.requestCaptchaIfNeeded = function requestCaptchaIfNeeded(mobile) {
    return function (dispatch, getState) {
        if (shouldRequestCaptcha(getState(), mobile)) {
            return dispatch(function (dispatch) {
                dispatch(requestCaptcha(mobile));
                return (0, _api.fetchCaptcha)(mobile).then(function (response) {
                    if (!response.ok) {
                        return Promise.reject(response);
                    }
                    return response.json();
                }).then(function (json) {
                    return dispatch(receiveCaptcha(mobile, json));
                }).catch(function (error) {
                    dispatch(failureCaptcha(error));
                });
            });
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/captcha.js
// module id = 892
// module chunks = 0